module.exports = __webpack_public_path__ + "static/media/reg.71f5f803.png";